import { createSelector } from 'reselect'
// import { List } from 'immutable'

const saleProductSelector = state => state.get('saleProduct')

export const getIsFetching = createSelector(
  saleProductSelector,
  saleProductImmutable => {
    const saleProduct = saleProductImmutable.toJS()
    return saleProduct.saleProductList.isFetching
    || saleProduct.saleProductGet.isFetching
    || saleProduct.saleProductUpdate.isFetching
    || saleProduct.saleProductCreate.isFetching
    || saleProduct.saleProductDelete.isFetching
    || saleProduct.saleProductExport.isFetching
  }
)

export const getSaleProductList = createSelector(
  saleProductSelector,
  saleProductImmutable => {
    const saleProduct = saleProductImmutable.toJS()
    return saleProduct.saleProductList.products || []
  }
)

export const getSaleProductData = createSelector(
  saleProductSelector,
  saleProductImmutable => {
    const saleProduct = saleProductImmutable.toJS()
    return saleProduct.saleProductGet.product
  }
)

export const getCreatedSaleProduct = createSelector(
  saleProductSelector,
  saleProductImmutable => {
    const saleProduct = saleProductImmutable.toJS()
    return saleProduct.saleProductCreate || {}
  }
)

export const getUpdatedSaleProduct = createSelector(
  saleProductSelector,
  saleProductImmutable => {
    const saleProduct = saleProductImmutable.toJS()
    return saleProduct.saleProductUpdate || {}
  }
)

export const getDeletedSaleProduct = createSelector(
  saleProductSelector,
  saleProductImmutable => {
    const saleProduct = saleProductImmutable.toJS()
    return saleProduct.saleProductDelete || {}
  }
)

export const getExportedSaleProduct = createSelector(
  saleProductSelector,
  saleProductImmutable => {
    const saleProduct = saleProductImmutable.toJS()
    return saleProduct.saleProductExport.url
  }
)

export const getSaleProduct = createSelector(
  saleProductSelector,
  saleProductImmutable => {
    const saleProduct = saleProductImmutable.toJS()
    return saleProduct.saleProduct || {}
  }
)

export const getKeywordSearch = createSelector(
  saleProductSelector,
  saleProductImmutable => {
    const saleProduct = saleProductImmutable.toJS()
    return saleProduct.saleProduct.keywordSearch
  }
)

export const isOpenManual = createSelector(
  saleProductSelector,
  saleProductImmutable => {
    const saleProduct = saleProductImmutable.toJS()
    return saleProduct.saleProductManual.isOpen
  }
)



// WEBPACK FOOTER //
// ./src/selectors/sale-product/sale-product-selector.js